import React, { useEffect, useState } from "react";
import api from "../../services/Api";

const ConfigurarDispositivo = () => {
  const [equipo, setEquipo] = useState(null);
  const id = new URLSearchParams(window.location.search).get('dispositivoId');
  useEffect(() => {
    if (!id) return;
    let vigente=true;
    api.get(`/Dispositivos/${id}/detalles`).then(({data})=>{if(vigente)setEquipo(data);}).catch(()=>{});
    return ()=>{vigente=false;};
  }, [id]);
  const ipValida = equipo?.ip && /^(\d{1,3}\.){3}\d{1,3}$/.test(equipo.ip) && equipo.ip.split('.').every(p=>Number(p)<=255);
  const openDevice = () => window.open("http://192.168.4.1", "_blank", "noopener,noreferrer");

  return (
    <section className="rounded-2xl border border-cyan-900/70 bg-gradient-to-br from-neutral-950 via-neutral-900 to-cyan-950/30 p-5 text-white shadow-xl sm:p-7">
      <p className="text-xs font-semibold uppercase tracking-[0.22em] text-cyan-400">Configuración local</p>
      <h3 className="mt-1 text-2xl font-bold">Conectar o cambiar Wi‑Fi</h3>
      <p className="mt-2 max-w-2xl text-sm leading-6 text-neutral-300">Las credenciales se introducen directamente en la página privada del dispositivo. El sistema web no recibe ni almacena la contraseña de tu red.</p>

      <p className="mt-4 text-sm text-neutral-300">Si el dispositivo aún está conectado, entra a su IP local desde la misma red. La dirección 192.168.4.1 corresponde a la red de recuperación del ESP32. Cambiar Wi-Fi no requiere reinstalar firmware ni reemplazar el dispositivo.</p>
      {ipValida && <p className="mt-4 text-sm text-neutral-300">{equipo.nombre}: <a href={`http://${equipo.ip}`} target="_blank" rel="noopener noreferrer">Abrir IP reportada {equipo.ip}</a> (desde su misma red local).</p>}
      <div className="mt-6 grid gap-4 md:grid-cols-3">
        <Step number="1" title="Busca la red" text="Si perdió la red, reinicia el ESP32 y espera aproximadamente 30 segundos. Conéctate a Piscicultura-XXXX-Tipo; XXXX son los últimos caracteres de la MAC." />
        <Step number="2" title="Abre el portal local" text="La clave Wi-Fi de fábrica es 76543211. Sin internet, en firmware 2.2.0 mantén BOOT tres segundos y consulta el código local por USB (115200)." />
        <Step number="3" title="Selecciona la nueva red" text="Entra a 192.168.4.1, desbloquea y guarda la nueva red y su contraseña. Para cambiar Wi-Fi conserva la clave IoT; solo se necesita al vincular inicialmente." />
      </div>

      <div className="mt-6 rounded-xl border border-neutral-700 bg-neutral-950/70 p-5">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div><div className="font-semibold">Portal local del ESP32</div><div className="mt-1 font-mono text-sm text-cyan-300">http://192.168.4.1</div></div>
          <button type="button" onClick={openDevice} className="rounded-xl bg-cyan-500 px-5 py-3 font-bold text-cyan-950 transition hover:bg-cyan-400">Abrir configuración local</button>
        </div>
      </div>

      <div className="mt-4 rounded-lg border border-amber-500/30 bg-amber-500/10 p-4 text-sm leading-6 text-amber-100">Si el navegador bloquea la página por estar en HTTP, escribe <b>192.168.4.1</b> directamente en la barra. Debes permanecer conectado a la red del ESP32. Después de guardar y reiniciar, vuelve a tu red habitual y verifica una comunicación reciente en Dispositivos.</div>
    </section>
  );
};

const Step = ({ number, title, text }) => (
  <div className="rounded-xl border border-neutral-700 bg-neutral-950/60 p-4">
    <div className="flex h-8 w-8 items-center justify-center rounded-full bg-cyan-500 font-bold text-cyan-950">{number}</div>
    <h4 className="mt-3 font-semibold">{title}</h4><p className="mt-1 text-sm leading-6 text-neutral-400">{text}</p>
  </div>
);

export default ConfigurarDispositivo;
